import React from 'react';
import { textHighlightColor } from './Colors';

const HighligthedText = ({ children }) => (
  <span style={{ backgroundColor: textHighlightColor }}>{children}</span>
);

export default HighligthedText;
